import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		index: true,
		lazy: () =>
			import("src/module--settings/pages/Settings.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: "profile",
		lazy: () =>
			import("src/module--settings/pages/Settings.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: "notifications",
		lazy: () =>
			import("src/module--settings/pages/NotificationsList.page").then(
				convertFrameworkRoute,
			),
	},
];
